var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('devices-table',{attrs:{"showAllDeviceDetails":true,"devicesList":_vm.partnerDevices,"devicePages":_vm.devicePages,"filteredSpaceId":_vm.filteredSpaceId,"showDeviceId":false,"clickable":true,"showSearchBar":true},on:{"search-params-input":function($event){return _vm.searchParamsInput($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }